// components/templates/sections/MARQUEE_COFFEE.tsx
import React from "react";
import { useDesign } from "@/context/DesignContext";

type MarqueeProps = {
  items?: string[] | string;
  design?: any;
};

export default function MARQUEE_COFFEE({ items = [], design: propDesign }: MarqueeProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;
  const itemsArray = Array.isArray(items) ? items : [];
  if (itemsArray.length === 0) return null;

  const bgColor = design?.colors?.background || "#0C0500";
  const textColor = design?.colors?.textLight || "#BFA76A";
  const separatorColor = design?.colors?.primary || "#C8622A";

  return (
    <div className="py-4 overflow-hidden border-y" style={{ background: bgColor, borderColor: `${separatorColor}4D` }}>
      <div className="marquee-track flex whitespace-nowrap gap-0">
        {Array(4).fill(null).map((_, i) =>
          itemsArray.map((t, j) => (
            <span key={`${i}-${j}`} className="font-mono-custom text-xs tracking-[0.4em] uppercase px-12" style={{ color: `${textColor}80` }}>
              {t} <span style={{ color: `${separatorColor}66` }}>◈</span>
            </span>
          ))
        )}
      </div>
    </div>
  );
}